<template>
  <div class="card modal-card">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">{{ $t('materiel.tlpe.informationTarifs.title')}}</h1>
          </div>
        </div>
      </div>
      <div class="card-content">
        <div class="rows">
          <div class="row">
            <div class="columns">
          <div class="column is-4">
            <b-field :label="$t('materiel.tlpe.informationTarifs.anne')">
              <b-select v-model="typeTaxeLigneId" expanded>
                <option v-for="ligne in typeTaxationTlpe.typeTaxationTlpeLignes"
                        :key="ligne.id"
                        :value="ligne.id">
                  {{ligne.anneeCivile}}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('materiel.tlpe.informationTarifs.montantAnnuel')"
                     class="has-text-right">
              <p class="mgt-15px has-text-weight-bold has-text-right">
                {{ getMontantAnnee * surfaceTlpe | formatDevise}}
              </p>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('materiel.tlpe.informationTarifs.montantHebdo')"
                     class="has-text-right">
              <p class="mgt-15px has-text-weight-bold has-text-right">
                {{ getMontantSemaine * surfaceTlpe | formatDevise}}
              </p>
            </b-field>
          </div>
        </div></div>
          <div class="row">
            <div class="columns">
          <div class="column is-4">
          </div>
          <div class="column is-4">
            <b-field :label="$t('materiel.tlpe.informationTarifs.montantAnnuelRefacture')"
                     class="has-text-right">
              <p class="mgt-15px has-text-weight-bold has-text-right">
                {{ getMontantAnnee * surfaceCommerciale | formatDevise}}
              </p>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('materiel.tlpe.informationTarifs.montantHebdoRefacture')"
                     class="has-text-right">
              <p class="mgt-15px has-text-weight-bold has-text-right">
                {{ getMontantSemaine * surfaceCommerciale | formatDevise}}
              </p>
            </b-field>
          </div>
        </div>
          </div>
        </div>
        <footer class="pdb-40px">
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('materiel.tlpe.informationTarifs.actions.cancel')}}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import messageErreur from '@/services/general/messageErreur';
import { get } from '@/api/typeTaxationTlpe';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'p_informationTarifsTlpe',
  props: {
    surfaceTlpe: {
      type: Number,
    },
    typeTaxationTlpeId: {
      type: String,
    },
    surfaceCommerciale: {
      type: Number,
    },
  },
  data() {
    return {
      typeTaxeLigneId: null,
      typeTaxationTlpe: [],
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    getMontantSemaine() {
      if (!this.typeTaxeLigneId) return 0;
      return this.typeTaxationTlpe.typeTaxationTlpeLignes.find((el) => {
        return el.id === this.typeTaxeLigneId;
      }).montantSemaine;
    },
    getMontantAnnee() {
      if (!this.typeTaxeLigneId) return 0;
      return this.typeTaxationTlpe.typeTaxationTlpeLignes.find((el) => {
        return el.id === this.typeTaxeLigneId;
      }).montantAnnuel;
    },
    getTypeTaxationTlpeLigneIdDefault() {
      const currentYear = this.typeTaxationTlpe.typeTaxationTlpeLignes.find((el) => {
        return el.anneeCivile === moment().year();
      });
      if (currentYear) return currentYear.id;
      if (this.typeTaxationTlpe.typeTaxationTlpeLignes.length === 0) return null;
      return this.typeTaxationTlpe.typeTaxationTlpeLignes[0].id;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.typeTaxationTlpe = (await get(this.typeTaxationTlpeId)).data.result;
      this.typeTaxationTlpe.typeTaxationTlpeLignes.sort((a, b) => {
        return b.anneeCivile.toString()
          .localeCompare(a.anneeCivile.toString(),
            undefined, { numeric: true });
      });
      this.typeTaxeLigneId = this.getTypeTaxationTlpeLigneIdDefault;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
